import { Todo } from "./Todo";
import { useGetTodosQuery } from "../features/todo/api/todoApi";
import { useSelector } from "react-redux";

export const Todos = () => {
    const { data, isLoading, isError } = useGetTodosQuery();
    const { option, colors } = useSelector((state) => state.filter) || {};

    const filterByOption = (todo) => {
        if (option !== 0) {
            switch (option) {
                case "all":
                    return todo;
                case "incomplete":
                    return !todo.completed;
                case "complete":
                    return todo.completed;
                default:
                    return true;
            }
        }
    };

    const filterByColor = (todo) => {
        if (colors.length > 0) {
            return colors.includes(todo?.color);
        }
        return true;
    };

    let content;

    if (isLoading) content = <p className="text-green-600">Loading...</p>;

    if (!isLoading && isError)
        content = <p className="text-red-600">Network problem !</p>;

    if (!isLoading && !isError && data?.length > 0) {
        content = data
            .filter(filterByOption)
            .filter(filterByColor)
            .map((todo) => {
                return <Todo key={todo.id} todo={todo} />;
            });
    }
    if (!isLoading && !isError && data?.length === 0)
        content = <p className="text-red-600">There have no todos !</p>;

    return (
        <>
            <div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
                {content}
            </div>
        </>
    );
};
